export default "__VITE_ASSET__BPZZTAIJ__"